export const USER_PREFERENCES_UPDATE = 'USER_PREFERENCES_UPDATE';
export const USER_PREFERENCES_FETCH_SUCCEEDED =
  'USER_PREFERENCES_FETCH_SUCCEEDED';
export const USER_PREFERENCES_UPDATED = 'USER_PREFERENCES_UPDATED';
